const HARDWARE = [
  { value: 'cutting', label: 'Cutting / fabrication' },
  { value: 'delivery', label: 'Delivery to site' },
  { value: 'loading', label: 'Loading / offloading labour' },
  { value: 'mixing', label: 'Mixing (paint, concrete, etc.)' },
  { value: 'other', label: 'Other (specify)' },
];

const RESTAURANT = [
  { value: 'catering', label: 'Catering / events' },
  { value: 'delivery', label: 'Food delivery' },
  { value: 'other', label: 'Other (specify)' },
];

const ELECTRONICS = [
  { value: 'repair', label: 'Repair service' },
  { value: 'installation', label: 'Installation' },
  { value: 'other', label: 'Other (specify)' },
];

const FURNITURE = [
  { value: 'delivery', label: 'Delivery' },
  { value: 'assembly', label: 'Assembly' },
  { value: 'other', label: 'Other (specify)' },
];

const PRINTING = [
  { value: 'wedding-card', label: 'Wedding card' },
  { value: 'report-writing', label: 'Report writing' },
  { value: 'other', label: 'Other (specify)' },
];

const PHARMACY = [
  { value: 'delivery', label: 'Medicine delivery' },
  { value: 'consultation', label: 'Consultation / dispensing fee' },
  { value: 'health-check', label: 'BP / glucose check' },
  { value: 'other', label: 'Other (specify)' },
];

const BAR_PUB = [
  { value: 'cover-charge', label: 'Cover / entry charge' },
  { value: 'dj-entertainment', label: 'DJ / live music' },
  { value: 'pool-table', label: 'Pool table / games' },
  { value: 'event-hire', label: 'Event / venue hire' },
  { value: 'corkage', label: 'Corkage (BYOB)' },
  { value: 'other', label: 'Other (specify)' },
];

const DEFAULT = [
  { value: 'service-fee', label: 'Service fee' },
  { value: 'delivery', label: 'Delivery' },
  { value: 'other', label: 'Other (specify)' },
];

const BY_TYPE = {
  pharmacy: PHARMACY,
  hardware: HARDWARE,
  hardware_with_wakala: HARDWARE,
  restaurant: RESTAURANT,
  electronics: ELECTRONICS,
  furniture: FURNITURE,
  stationary: PRINTING,
  bar_pub: BAR_PUB,
  bar_pub_with_wakala: BAR_PUB,
  service_business: DEFAULT,
};

export function otherServiceOptionsForUser(user) {
  const code = user?.tenant?.businessType || '';
  return BY_TYPE[code] || DEFAULT;
}
